import { useState } from 'react'
import { useRouter } from 'next/router'

import { Stack } from '@mui/material'
import { LinkText } from '@core/components/common/Button'
import { ArrowLeftIcon } from '@core/components/icons'
import { BackdropLoader } from '@core/components/ui/BackdropLoader/BackdropLoader'
import { AlertDialog } from '@core/components/ui/CustomDialog'
import { useLayout } from '@core/contexts/layout'
import { colors } from '@core/helpers'
import { LoginLayout } from '@components/Login/LoginLayout'
import { LoginTopInfo } from '@components/Login/LoginTopInfo'

import { DNIForm } from '../DNIForm'
import { RegisterForm } from '../RegisterForm/RegisterForm'
import { useRegister } from './useRegister'

export const Register = () => {
  const router = useRouter()
  const { isMobile } = useLayout()

  const [openExistsUserModal, setOpenExistsUserModal] = useState(false)

  const { loading, onClickBack, onRegister, onSubmitDNIForm, showCompleteRegisterForm } =
    useRegister(
      () => setOpenExistsUserModal(true),
      data => {
        router.push(`/autenticacion/registro/correcto?name=${data.name}`)
      }
    )

  return (
    <LoginLayout title='Registro - Portal aviva'>
      {!isMobile && (
        <LoginTopInfo
          href='/autenticacion/iniciar-sesion'
          textButton='Inicia sesión'
          textLabel='¿Ya tienes cuenta?'
          sxContainer={{ mb: showCompleteRegisterForm ? '5.3rem' : '13.2rem' }}
        />
      )}
      {isMobile && (
        <LinkText
          typographyProps={{
            fontWeight: 600
          }}
          customIcon={(_, size) => <ArrowLeftIcon size={size} color={colors.primary_darkest} />}
          text='Atrás'
          onClick={showCompleteRegisterForm ? onClickBack : undefined}
          href={showCompleteRegisterForm ? undefined : '/autenticacion/iniciar-sesion'}
          iconUbi='left'
          color={colors.primary_darkest}
          styleContainer={{
            marginTop: '2.4rem',
            marginBottom: '3.2rem'
          }}
        />
      )}
      {!showCompleteRegisterForm ? (
        <DNIForm wrapperMaxWidth='100%' onSubmitDNIForm={onSubmitDNIForm} />
      ) : (
        <Stack>
          {!isMobile && (
            <LinkText
              typographyProps={{
                fontWeight: 600
              }}
              customIcon={(color, size) => (
                <ArrowLeftIcon size={size} color={colors.primary_darkest} />
              )}
              onClick={onClickBack}
              text='Atrás'
              iconUbi='left'
              color={colors.primary_darkest}
              styleContainer={{
                marginTop: '2.4rem',
                marginBottom: '5.8rem'
              }}
            />
          )}
          <RegisterForm onRegister={onRegister} enableMaxWidth={false} />
        </Stack>
      )}
      <AlertDialog
        open={openExistsUserModal}
        setOpen={setOpenExistsUserModal}
        type='info'
        description={
          'Hemos detectado que ya tienes un usuario en nuestro sistema, \n por favor inicia o sesión o restablece tu contraseña'
        }
        onClose={() => setOpenExistsUserModal(false)}
        title='Cuenta existente'
        footerButtonText='Iniciar sesión'
        onContinue={() => router.push('/autenticacion/iniciar-sesion')}
      />
      <BackdropLoader loading={loading} title='Estamos validando tu información' />
    </LoginLayout>
  )
}
